module.exports = __webpack_public_path__ + "media/src/images/icons/giftee-app-icon-e19e5e3081397016e0811003b0d55391.png";